import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { MiscDirectivesModule } from "@app/directives/_misc/_misc.directives.module";
import { PipesModule } from "@app/_pipes/_pipes.module";
import { VideoRestrictionComponent } from "./components/videoRestriction.component";
import { TemperatureRowComponent } from "./temperature-row.component";
import { DriverTachoSummaryComponent } from "./driver-tacho-summary/driver-tacho-summary.component";
import { VeriDirectivesModule } from "@app/directives/_veri/_veri.directives.module";



const privateComponents: any[] = [

];

const publicComponents: any[] = [
    VideoRestrictionComponent,
    TemperatureRowComponent,
    DriverTachoSummaryComponent
];


@NgModule({
    imports: [
        CommonModule,
        MiscDirectivesModule,
        VeriDirectivesModule,
        PipesModule
    ],
    entryComponents: [...publicComponents, ...privateComponents],
    declarations: [...publicComponents, ...privateComponents,],
    exports: [...publicComponents],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LiveMapModule {
    constructor() {
    }
}
